export const lbm = [
  {
    month: 'Jan',
    count: 121,
  },
  {
    month: 'Feb',
    count: 66,
  },
  {
    month: 'Mar',
    count: 207,
  },
  {
    month: 'Apr',
    count: 8,
  },
  {
    month: 'May',
    count: 54,
  },
  {
    month: 'Jun',
    count: 185,
  },
  {
    month: 'Jul',
    count: 5,
  },
  {
    month: 'Aug',
    count: 0,
  },
  {
    month: 'Sep',
    count: 0,
  },
  {
    month: 'Oct',
    count: 262,
  },
  {
    month: 'Nov',
    count: 220,
  },
  {
    month: 'Dec',
    count: 24,
  },
]
